import script from "./ModalNuevoDiseno.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalNuevoDiseno.vue?vue&type=script&setup=true&lang=js"

import "./ModalNuevoDiseno.vue?vue&type=style&index=0&id=776103b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-776103b4"]])

export default __exports__